module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/credigas-estacionario/detalles/estacionario-detalles.component.scss
// module id = ./src/app/creditos/credigas-estacionario/detalles/estacionario-detalles.component.scss
// module chunks = main